import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// Flex Layout
import { FlexLayoutModule } from '@angular/flex-layout';

// Scroll To
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';

// Carousel
import { DragScrollModule } from 'ngx-drag-scroll';
import {Nl2BrPipeModule} from 'nl2br-pipe';

//Recaptcha
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha';

// Angular Material
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatPaginatorModule, MatPaginatorIntl } from '@angular/material/paginator';
import { getEspPaginatorIntl } from './elements/paginator-esp/matPaginatorIntlEspClass'

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavbarComponent } from './elements/navbar/navbar.component';
import { FooterComponent } from './elements/footer/footer.component';
import { HomeComponent } from './pages/home/home.component';
import { TermsComponent } from './pages/terms/terms.component';
import { CartComponent } from './pages/cart/cart.component';
import { SimilarProductsComponent } from './elements/similar-products/similar-products.component';
import { FaqsQuestionsComponent } from './elements/faqs-questions/faqs-questions.component';
import { ParallaxDirective } from './parallax.directive';
import { HelpCenterComponent } from './pages/help-center/help-center.component';
import { ProductDetailsComponent } from './pages/product-details/product-details.component';
import { AddProductCartComponent } from './elements/add-product-cart/add-product-cart.component';
import { SearchComponent } from './pages/search/search.component';
import { FiltersComponent } from './pages/search/filters/filters.component';
import { ProductCardComponent } from './elements/product-card/product-card.component';
import { SeparateBarPromoComponent } from './pages/home/separate-bar-promo/separate-bar-promo.component';
import { BreadcrumbComponent } from './elements/breadcrumb/breadcrumb.component';
import { CheckoutComponent } from './pages/checkout/checkout.component';
import { ResumeComponent } from './pages/checkout/resume/resume.component';
import { StepOneComponent } from './pages/checkout/step-one/step-one.component';
import { StepTwoComponent } from './pages/checkout/step-two/step-two.component';
import { StepThreeComponent } from './pages/checkout/step-three/step-three.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { LoadingComponent } from './elements/loading/loading.component';
import { LoginComponent } from './elements/navbar/login/login.component';
import { MyProfileComponent } from './pages/my-profile/my-profile.component';
import { MyShoppingComponent } from './pages/my-profile/my-shopping/my-shopping.component';
import { PaymentInstallmentComponent } from './elements/view-mount-card/view-mount-card.component';
import { FavoritesComponent } from './pages/my-profile/favorites/favorites.component';
import { HttpClientModule } from '@angular/common/http';
import { environment } from 'src/environments/environment';

import { MenuNestedItemComponent } from './elements/menu-nested-item/menu-nested-item.component';
import { AuthenticationModule } from '@mobileia/authentication';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StorageModule } from '@ngx-pwa/local-storage';

import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { StepFourComponent } from './pages/checkout/step-four/step-four.component';
import { MyProfileSectionComponent } from './pages/my-profile/my-profile-section/my-profile-section.component';
import { StepFiveComponent } from './pages/checkout/step-five/step-five.component';
import { HowBuyComponent } from './elements/dialog-questions/how-buy/how-buy.component';
import { OnlyNumberDirective } from './pipes/only-number.directive';
import { MatTableModule } from '@angular/material/table';
import { AsociateComponent } from './pages/asociate/asociate.component';
import { CommonModule } from '@angular/common';
import { PaymentRedirectComponent } from './pages/payment-redirect/payment-redirect.component';

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    FooterComponent,
    HomeComponent,
    TermsComponent,
    CartComponent,
    SimilarProductsComponent,
    FaqsQuestionsComponent,
    ParallaxDirective,
    HelpCenterComponent,
    ProductDetailsComponent,
    AddProductCartComponent,
    SearchComponent,
    FiltersComponent,
    ProductCardComponent,
    SeparateBarPromoComponent,
    BreadcrumbComponent,
    CheckoutComponent,
    ResumeComponent,
    StepOneComponent,
    StepTwoComponent,
    StepThreeComponent,
    PageNotFoundComponent,
    LoadingComponent,
    LoginComponent,
    MyProfileComponent,
    MyShoppingComponent,
    PaymentInstallmentComponent,
    FavoritesComponent,
    MenuNestedItemComponent,
    StepFourComponent,
    MyProfileSectionComponent,
    StepFiveComponent,
    HowBuyComponent,
    OnlyNumberDirective,
    AsociateComponent,
    PaymentRedirectComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    FlexLayoutModule,
    MatToolbarModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatBadgeModule,
    MatButtonModule,
    MatTabsModule,
    MatTableModule,
    MatListModule,
    MatTooltipModule,
    MatExpansionModule,
    MatPaginatorModule,
    DragScrollModule,
    ScrollToModule.forRoot(),
    MatAutocompleteModule,
    MatDialogModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatSidenavModule,
    MatProgressSpinnerModule,
    MatMenuModule,
    MatStepperModule,
    HttpClientModule,
    AuthenticationModule.forRoot({apiKey: '16', isInternal: true, baseUrlInternal: environment.baseUrl }),
    StorageModule.forRoot({ IDBNoWrap: false }),
    SweetAlert2Module.forRoot(),
    Nl2BrPipeModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  entryComponents: [
    AddProductCartComponent,
  ],
  providers: [{ provide: MatPaginatorIntl, useValue: getEspPaginatorIntl()}],
  bootstrap: [AppComponent]
})
export class AppModule { }
export class AsociateModule { }
